<script>
  import printJS from "print-js";
  import { scrollTo } from "../../../library/function/browser";
  import Link from "./Link.svelte";
  export let fab_item = {};
  export let classNames = "";

  // Get the element to print.
  let { target } = fab_item.extraOptions.print;
  const element = document.querySelector(target);

  // If no element is found, then print the body.
  if (!element) {
    target = "body";
  }

  // Handle click.
  function handle_click(e) {
    jQuery(document).ready(function () {
      if (target !== "body") {
        let type = "html";
        type = [".jpg", ".png", ".gif"].includes(type) ? "image" : type;
        type = [".pdf"].includes(type) ? "" : type;
        printJS(target.replace("#", ""), type);
      } else {
        window.print();
      }
    });
  }
</script>

<Link {fab_item} {classNames} on:click={handle_click} />
